import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EncodeDecodeService {

  private _encodeDecodeSubject = new BehaviorSubject<Object>({});

  constructor() { }

  getEncodeDecodeSubject() {
    return this._encodeDecodeSubject.asObservable();
  }

  resetEncode() {
    this._encodeDecodeSubject.next({});
  }

  decodeToken(token) {
    if (token) {
      let aux = token.substr(token.indexOf('.') + 1, token.length);
      let payload = aux.substr(0, aux.indexOf('.'));
      this._encodeDecodeSubject.next(JSON.parse(atob(payload)));
      let obj = JSON.parse(atob(payload));
      for (let [key, value] of Object.entries(obj)) {
        if (typeof value == 'string') {
          obj[key] = decodeURIComponent(escape(value));
        }
      }
      return obj;
    } else {
      return '';
    }
  }

  decodeBase64(valueToDecode: string) {
    return JSON.parse(atob(valueToDecode));
  }

  encodeBase64(valueToEncode: any) {
    return btoa(JSON.stringify(valueToEncode));
  }

}
